import { useTransportMutation } from "@/transport"

export function useDeleteTestSetsTransport() {
  return useTransportMutation("deleteTestSets")
}
